<template>
  <component :is="tagName" :href="hrefLink" class="point-trade-card-container" :style="{width}">
    <div :style="cardStyle" :class="className">
      <AspectRatio class="goods-card_image" :ratio="ratio">
        <van-image :src="data.image_url" :fit="fit" width="100%" height="100%"/>
      </AspectRatio>
      <div :class="infoClass" v-if="config.show_title||config.show_price||config.show_origin_price||config.show_buy_btn">
        <div class="goods_card_name" v-if="config.show_title">
          <p class="name" :style="[400,500][config.text_style_type]">{{data.title}}</p>
        </div>
        <div class="goods_card_price" v-if="config.show_price||config.show_buy_btn">
          <div class="price-block" v-if="config.show_price">
            <p class="price point">{{data.trade_point}}分</p>
            <p class="price" v-if="data.price"> +￥{{data.price}}</p>
          </div>
          <BuyBtn :config="config" @click="callBuyAction" :loading="buyLoading" prevent/>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
  import AspectRatio from "@/components/AspectRatio";
  import GoodsCard from '../mixins/GoodsCard';
  import GoodsSku from '../mixins/GoodsSku';
  import BuyBtn from '../BuyBtn';

  export default {
	name: "GoodsCard",
	mixins: [GoodsCard, GoodsSku],
	components: {AspectRatio, BuyBtn},
	props: {
	  config: Object,
	  data: Object,
	  index: Number
	},
	data() {
	  return {};
	},
	computed: {},
  };
</script>

<style lang="less" rel="stylesheet/less">

  .point-trade-card-container {
    float: left;

    .goods-card {
      overflow: hidden;
      position: relative;
      box-sizing: border-box;

      &.list {
        height: 120px;
        display: flex;

        .goods-card_image {
          flex-basis: 120px;
          flex-shrink: 0;
        }

        .goods-card_info {
          flex: 1;

          .goods_card_name {
            height: 60px;

            .name {
              .limit-line(3);
            }
          }

          div.buy-btn-block {
            top: 15px;
          }
        }
      }

      .corner-mark {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        line-height: 1;

        svg {
          font-size: 40px;
        }

        .corner-mark_custom {
          p {
            width: 2em;
            padding: 5px;
            font-size: 12px;
            background-color: rgba(0, 0, 0, 0.08);
          }
        }
      }

      .goods-card_info {
        padding: 10px 10px 0;
        position: relative;

        &.goods-card_align-left {
          text-align: left;

          .goods_card_price {
            display: flex;;
            align-items: center;
            justify-content: space-between;
          }

          .buy-btn-block {
            top: 10px;
            right: 0;
          }
        }

        &.goods-card_align-center {
          text-align: center;

          .goods_card_price {
            flex-direction: column;
            height: auto;

            .buy-btn {
              margin: 5px 0 8px;
            }
          }
        }

        .goods_card_name {
          height: 40px;

          .name {
            .limit-line;
            font-size: 14px;
            margin-bottom: 5px;
            line-height: 20px;
          }

        }

        .goods_card_price {
          position: relative;
          height: 40px;
          display: flex;
          align-items: center;
          padding-top: 5px;

          .price-block {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;

            .price {
              color: @text-color-price;
            }

            .origin-price {
              margin-left: 6px;
              text-decoration: line-through;
              color: @text-color-gray;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

</style>
